import { useEffect, useState } from "react";
import { Banknote, Bell, Globe, Image as ImageIcon, MessageCircle, Network, PenLine, Star } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { enablePush, pushSupported } from "../lib/pwa";
import { toast } from "sonner";

export default function Accueil() {
  const [notifState, setNotifState] = useState("idle");
  useEffect(() => {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") setNotifState("on");
  }, []);
  const tiles = [
    ["Le site", "Voir le site complet", Globe, "/", "tile-site"],
    ["Messages", "Lire et répondre", MessageCircle, "/admin", "tile-messages"],
    ["Médias", "Photos & vidéos", ImageIcon, "/admin?tab=media", "tile-media"],
    ["Paiements", "Encaisser & rembourser", Banknote, "/admin?tab=payments", "tile-payments"],
    ["Réseaux sociaux", "Vos pages & DM", Network, "/admin?tab=social", "tile-social"],
    ["Avis clients", "Publier les témoignages", Star, "/admin?tab=reviews", "tile-reviews"],
    ["Modifier le site", "Textes & images", PenLine, "/admin?tab=content", "tile-content"],
  ];
  const enableNotifs = async () => {
    try {
      await enablePush();
      setNotifState("on");
      toast.success("Notifications activées.");
    } catch (e) { toast.error(e?.message || "Activation impossible."); }
  };
  return (
    <div className="min-h-[100svh] overflow-x-hidden bg-[#0a0908] px-5 pb-16 pt-14" data-testid="app-home">
      <div className="mx-auto max-w-md">
        <div className="flex flex-col items-center text-center">
          <Logo size={72} />
          <h1 className="mt-5 font-display text-3xl text-amber-50">Maître Wouffa</h1>
          <p className="mt-2 text-sm text-stone-400">Votre application : le site et sa gestion complète.</p>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3">
          {tiles.map(([name, sub, Icon, href, id]) => (
            <a key={id} href={href} data-testid={`app-${id}`}
              className="flex h-32 flex-col justify-between rounded-3xl border border-amber-900/40 bg-[#181512] p-4 transition-colors duration-300 hover:border-amber-500/60">
              <Icon className="h-6 w-6 text-amber-400" />
              <span>
                <span className="block font-serif-it text-xl italic text-amber-100">{name}</span>
                <span className="block text-xs text-stone-400">{sub}</span>
              </span>
            </a>
          ))}
          {pushSupported() && (
            <button onClick={enableNotifs} disabled={notifState === "on"} data-testid="app-tile-notifs"
              className="flex h-32 flex-col justify-between rounded-3xl border border-amber-500/50 bg-amber-400/10 p-4 text-left transition-colors duration-300 hover:bg-amber-400/20">
              <Bell className="h-6 w-6 text-amber-300" />
              <span>
                <span className="block font-serif-it text-xl italic text-amber-100">Notifications</span>
                <span className="block text-xs text-amber-300/80">{notifState === "on" ? "Activées" : "Activer maintenant"}</span>
              </span>
            </button>
          )}
        </div>
        <p className="mt-10 text-center text-xs text-stone-500">Connexion requise pour la gestion — même compte partout.</p>
      </div>
    </div>
  );
}
